export interface Video {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  platform: string;
  platformSlug: string;
  coverImage: string;
  description: string;
  duration: string;
  releaseDate: string;
  rating: number;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  content: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { name: "最新电影", slug: "latest-movies", icon: "ri-movie-2-line", description: "最新上映的国内外大片，高清画质免费看", count: 128 },
  { name: "热播电视剧", slug: "tv-series", icon: "ri-tv-2-line", description: "热门国产剧、网络剧追剧首选", count: 256 },
  { name: "美剧专区", slug: "american-drama", icon: "ri-earth-line", description: "经典美剧、最新美剧一网打尽", count: 189 },
  { name: "韩剧专区", slug: "korean-drama", icon: "ri-heart-line", description: "韩剧控的天堂，浪漫爱情应有尽有", count: 142 },
  { name: "综艺娱乐", slug: "variety-show", icon: "ri-emotion-laugh-line", description: "热门综艺、搞笑娱乐放松心情", count: 98 },
  { name: "动漫番剧", slug: "anime", icon: "ri-ghost-line", description: "日漫国漫新番连载，二次元世界", count: 215 },
  { name: "纪录片", slug: "documentary", icon: "ri-camera-line", description: "BBC、Discovery等精品纪录片", count: 67 },
];

export const platforms = [
  { name: "香蕉视频", slug: "banana" },
  { name: "红桃视频", slug: "peach" },
  { name: "91视频", slug: "91" },
];

export const videos: Video[] = [
  {
    id: "v001",
    title: "流浪地球3：星际远征",
    category: "最新电影",
    categorySlug: "latest-movies",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20image%20showing%20a%20futuristic%20spaceship%20flying%20through%20a%20colorful%20nebula%20with%20stars%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20composition%2C%20dark%20background%20with%20subtle%20gradient%2C%20cinematic%20photography%20style&width=800&height=450&seq=video-cover-001&orientation=landscape",
    description: "在太阳系面临前所未有的危机时，人类必须做出艰难抉择。刘培强带领新一代宇航员踏上了拯救地球的星际远征之路，穿越未知星系，面对神秘外星文明的考验。",
    duration: "148分钟",
    releaseDate: "2026-07-15",
    rating: 9.2,
    views: 1528000,
    tags: ["科幻", "冒险", "国产大片", "IMAX"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n在太阳系面临前所未有的危机时，人类必须做出艰难抉择。刘培强带领新一代宇航员踏上了拯救地球的星际远征之路。\n\n## 影片看点\n\n- 顶尖特效团队打造震撼视觉体验\n- 实力派演员倾情演绎\n- 全新升级的IMAX拍摄技术\n- 感人至深的家国情怀",
  },
  {
    id: "v002",
    title: "长安十二时辰之暗夜追踪",
    category: "热播电视剧",
    categorySlug: "tv-series",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20drama%20poster%20style%2C%20ancient%20Tang%20Dynasty%20cityscape%20at%20night%20with%20lanterns%2C%20a%20detective%20figure%20in%20traditional%20robe%2C%20warm%20golden%20and%20red%20tones%2C%20mysterious%20atmosphere%2C%20clean%20composition%2C%20cinematic%20look&width=800&height=450&seq=video-cover-002&orientation=landscape",
    description: "天宝三载，上元节前夕，长安城内暗流涌动。靖安司司丞李必与死囚张小敬联手，在十二时辰内破解一桩关乎全城百姓性命的惊天阴谋。",
    duration: "共48集",
    releaseDate: "2026-06-20",
    rating: 9.5,
    views: 3250000,
    tags: ["古装", "悬疑", "历史", "精品剧"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n天宝三载，上元节前夕，长安城内暗流涌动。靖安司司丞李必与死囚张小敬联手，在十二时辰内破解一桩关乎全城百姓性命的惊天阴谋。\n\n## 追剧理由\n\n- 精良制作，每一帧都是壁纸\n- 剧情紧凑，环环相扣\n- 实力派演员阵容\n- 高度还原盛唐风貌",
  },
  {
    id: "v003",
    title: "星际之门：新纪元",
    category: "美剧专区",
    categorySlug: "american-drama",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20sci-fi%20TV%20series%20poster%20with%20a%20mysterious%20portal%20glowing%20in%20deep%20space%2C%20silhouettes%20of%20explorers%2C%20blue%20and%20gold%20energy%20waves%2C%20cinematic%20lighting%2C%20clean%20composition%2C%20dramatic%20atmosphere&width=800&height=450&seq=video-cover-003&orientation=landscape",
    description: "一支国际探险队发现了一个古老的外星传送门网络，可以瞬间穿越到宇宙任何角落。然而每次穿越都可能唤醒沉睡的远古威胁。",
    duration: "第3季更新中",
    releaseDate: "2026-05-10",
    rating: 9.1,
    views: 980000,
    tags: ["科幻", "冒险", "美剧", "连载"],
    isHot: true,
    isNew: false,
    content: "## 剧情简介\n\n一支国际探险队发现了一个古老的外星传送门网络，可以瞬间穿越到宇宙任何角落。然而每次穿越都可能唤醒沉睡的远古威胁。\n\n## 推荐理由\n\n- 特效堪比好莱坞大片\n- 每集都有新世界探索\n- 剧情悬念迭起\n- 角色塑造立体丰满",
  },
  {
    id: "v004",
    title: "来自星星的你2：重逢",
    category: "韩剧专区",
    categorySlug: "korean-drama",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20drama%20poster%20style%2C%20a%20couple%20standing%20under%20a%20starry%20night%20sky%2C%20soft%20pink%20and%20purple%20tones%2C%20dreamy%20atmosphere%2C%20romantic%20composition%2C%20clean%20aesthetic%2C%20gentle%20lighting&width=800&height=450&seq=video-cover-004&orientation=landscape",
    description: "都敏俊时隔七年重返地球，却发现千颂伊已经忘记了他。一场跨越时空的爱情故事再次展开，比上一季更加催泪。",
    duration: "共16集",
    releaseDate: "2026-07-01",
    rating: 9.3,
    views: 2100000,
    tags: ["爱情", "奇幻", "韩剧", "催泪"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n都敏俊时隔七年重返地球，却发现千颂伊已经忘记了他。一场跨越时空的爱情故事再次展开。\n\n## 必看理由\n\n- 原班人马回归\n- 画面唯美如画\n- 配乐动人心弦\n- 情感细腻真挚",
  },
  {
    id: "v005",
    title: "极限挑战第十季",
    category: "综艺娱乐",
    categorySlug: "variety-show",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20variety%20show%20poster%20with%20a%20group%20of%20celebrities%20having%20fun%20outdoors%2C%20bright%20and%20vibrant%20colors%2C%20energetic%20atmosphere%2C%20warm%20sunlight%2C%20clean%20composition%2C%20playful%20and%20cheerful%20vibe&width=800&height=450&seq=video-cover-005&orientation=landscape",
    description: "极限男人帮再度集结，全新一季挑战升级。从沙漠求生到极地探险，笑料不断，温暖依旧。",
    duration: "更新至第8期",
    releaseDate: "2026-06-15",
    rating: 8.8,
    views: 4560000,
    tags: ["综艺", "搞笑", "户外", "真人秀"],
    isHot: true,
    isNew: false,
    content: "## 节目简介\n\n极限男人帮再度集结，全新一季挑战升级。从沙漠求生到极地探险，笑料不断，温暖依旧。\n\n## 看点\n\n- 原班人马默契升级\n- 挑战难度全面升级\n- 笑中带泪的真情实感\n- 全国各地美景尽收眼底",
  },
  {
    id: "v006",
    title: "进击的巨人 最终季 完结篇",
    category: "动漫番剧",
    categorySlug: "anime",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=An%20anime%20style%20poster%20showing%20a%20colossal%20titan%20against%20a%20dramatic%20sunset%20sky%2C%20dark%20silhouettes%20of%20soldiers%2C%20epic%20scale%2C%20warm%20orange%20and%20crimson%20tones%2C%20clean%20composition%2C%20cinematic%20anime%20art&width=800&height=450&seq=video-cover-006&orientation=landscape",
    description: "艾伦发动地鸣，世界陷入混乱。三笠、阿尔敏等人做出了最终的选择。这部史诗级动漫迎来了震撼人心的完结。",
    duration: "共2集特别篇",
    releaseDate: "2026-04-08",
    rating: 9.7,
    views: 5200000,
    tags: ["动漫", "热血", "完结", "神作"],
    isHot: true,
    isNew: false,
    content: "## 剧情简介\n\n艾伦发动地鸣，世界陷入混乱。三笠、阿尔敏等人做出了最终的选择。\n\n## 为什么是神作\n\n- 十年连载完美收官\n- 动画制作水准顶级\n- 深刻的人性探讨\n- 令人震撼的结局",
  },
  {
    id: "v007",
    title: "蓝色星球3：深海探秘",
    category: "纪录片",
    categorySlug: "documentary",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20nature%20documentary%20poster%20showing%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20crystal%20clear%20blue%20water%2C%20mysterious%20underwater%20landscape%2C%20warm%20and%20cool%20color%20contrast%2C%20clean%20composition%2C%20cinematic%20underwater%20photography&width=800&height=450&seq=video-cover-007&orientation=landscape",
    description: "BBC金牌团队历时五年，深入地球最神秘的深海世界。拍摄到前所未见的深海生物和地质奇观，每一帧都令人叹为观止。",
    duration: "共8集",
    releaseDate: "2026-03-20",
    rating: 9.8,
    views: 1890000,
    tags: ["纪录片", "自然", "BBC", "深海"],
    isHot: false,
    isNew: false,
    content: "## 内容简介\n\nBBC金牌团队历时五年，深入地球最神秘的深海世界。拍摄到前所未见的深海生物和地质奇观。\n\n## 推荐理由\n\n- 4K超高清画质\n- 前所未见的深海生物\n- 专业的科学解说\n- 震撼人心的配乐",
  },
  {
    id: "v008",
    title: "封神三部曲之昆仑之战",
    category: "最新电影",
    categorySlug: "latest-movies",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20mythological%20fantasy%20film%20poster%2C%20ancient%20Chinese%20gods%20and%20warriors%20in%20epic%20battle%2C%20golden%20and%20crimson%20tones%2C%20divine%20lighting%20effects%2C%20dramatic%20composition%2C%20cinematic%20Chinese%20fantasy%20art%20style&width=800&height=450&seq=video-cover-008&orientation=landscape",
    description: "姜子牙率领众神在昆仑山与纣王展开终极对决，封神榜的秘密即将揭晓。国产神话史诗巨制，视觉盛宴不容错过。",
    duration: "156分钟",
    releaseDate: "2026-08-01",
    rating: 8.9,
    views: 890000,
    tags: ["奇幻", "神话", "国产大片", "史诗"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n姜子牙率领众神在昆仑山与纣王展开终极对决，封神榜的秘密即将揭晓。\n\n## 观影指南\n\n- 中国神话宇宙巅峰之作\n- 顶级特效团队打造\n- 集结华语影坛顶级演员\n- 建议IMAX观影体验最佳",
  },
  {
    id: "v009",
    title: "鱿鱼游戏2：第二轮",
    category: "韩剧专区",
    categorySlug: "korean-drama",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20thriller%20drama%20poster%20with%20geometric%20shapes%20and%20mysterious%20game%20elements%2C%20dark%20background%20with%20pink%20and%20green%20accent%20colors%2C%20suspenseful%20atmosphere%2C%20clean%20composition%2C%20cinematic%20style&width=800&height=450&seq=video-cover-009&orientation=landscape",
    description: "成奇勋重返组织，誓要揭开游戏背后的真相。全新的致命游戏，更残酷的规则，谁能活到最后？",
    duration: "共9集",
    releaseDate: "2026-07-25",
    rating: 9.0,
    views: 6800000,
    tags: ["悬疑", "惊悚", "韩剧", "生存"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n成奇勋重返组织，誓要揭开游戏背后的真相。全新的致命游戏，更残酷的规则，谁能活到最后？\n\n## 看点\n\n- 全球现象级续作\n- 全新游戏设计更刺激\n- 深入揭秘幕后组织\n- 李政宰演技炸裂",
  },
  {
    id: "v010",
    title: "咒术回战 第三季",
    category: "动漫番剧",
    categorySlug: "anime",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20poster%20with%20a%20young%20sorcerer%20surrounded%20by%20dark%20energy%20and%20curses%2C%20dynamic%20action%20pose%2C%20dark%20and%20vibrant%20color%20contrast%2C%20warm%20orange%20accents%2C%20clean%20composition%2C%20shonen%20anime%20art&width=800&height=450&seq=video-cover-010&orientation=landscape",
    description: "虎杖悠仁在涩谷事变后，踏上了新的修炼之路。更强大的咒灵，更复杂的阴谋，咒术高专的命运将何去何从？",
    duration: "更新至第12集",
    releaseDate: "2026-07-08",
    rating: 9.4,
    views: 4100000,
    tags: ["动漫", "热血", "战斗", "连载"],
    isHot: true,
    isNew: true,
    content: "## 剧情简介\n\n虎杖悠仁在涩谷事变后，踏上了新的修炼之路。更强大的咒灵，更复杂的阴谋，咒术高专的命运将何去何从？\n\n## 追番理由\n\n- Mappa制作质量保证\n- 战斗场面燃到爆炸\n- 剧情深度持续提升\n- 人气角色悉数回归",
  },
  {
    id: "v011",
    title: "繁花似锦",
    category: "热播电视剧",
    categorySlug: "tv-series",
    platform: "香蕉视频",
    platformSlug: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20modern%20drama%20poster%20showing%20a%20fashionable%20woman%20in%20a%20luxurious%20urban%20setting%2C%20warm%20golden%20lighting%2C%20elegant%20composition%2C%20sophisticated%20and%20modern%20Chinese%20aesthetic%2C%20clean%20background&width=800&height=450&seq=video-cover-011&orientation=landscape",
    description: "讲述上海滩三位女性在商海沉浮中奋斗成长的故事。从职场小白到商界精英，她们用智慧和勇气书写了属于自己的传奇。",
    duration: "共42集",
    releaseDate: "2026-06-10",
    rating: 8.7,
    views: 2780000,
    tags: ["都市", "女性", "职场", "励志"],
    isHot: false,
    isNew: true,
    content: "## 剧情简介\n\n讲述上海滩三位女性在商海沉浮中奋斗成长的故事。从职场小白到商界精英，她们用智慧和勇气书写了属于自己的传奇。\n\n## 追剧理由\n\n- 真实还原职场生态\n- 三位女主精彩演绎\n- 时尚穿搭引领潮流\n- 励志正能量满满",
  },
  {
    id: "v012",
    title: "怪奇物语 第五季",
    category: "美剧专区",
    categorySlug: "american-drama",
    platform: "红桃视频",
    platformSlug: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=A%20retro%2080s%20style%20TV%20show%20poster%20with%20kids%20on%20bicycles%20under%20a%20dark%20red%20sky%2C%20mysterious%20atmosphere%2C%20neon%20accents%2C%20nostalgic%20vibe%2C%20cinematic%20composition%2C%20warm%20and%20dark%20color%20scheme&width=800&height=450&seq=video-cover-012&orientation=landscape",
    description: "霍金斯小镇的终极之战，十一和伙伴们必须面对有史以来最强大的敌人。颠倒世界的秘密即将全部揭晓。",
    duration: "共8集",
    releaseDate: "2026-05-30",
    rating: 9.3,
    views: 3500000,
    tags: ["科幻", "恐怖", "美剧", "怀旧"],
    isHot: false,
    isNew: false,
    content: "## 剧情简介\n\n霍金斯小镇的终极之战，十一和伙伴们必须面对有史以来最强大的敌人。颠倒世界的秘密即将全部揭晓。\n\n## 追剧理由\n\n- 经典系列最终季\n- 80年代复古情怀拉满\n- 小演员们演技成熟\n- 特效全面升级",
  },
];